import { __extends } from "tslib";
import React, { Component } from 'react';
import { MoloRingloader } from './layout/MoloRingloader';
// Images.
import ReorderSwim from './images/collections/reorder/swim.jpg';
import ReorderMain from './images/collections/reorder/main.jpg';
import ReorderOuterWear from './images/collections/reorder/outerwear.jpg';
import ReorderFriendship from './images/collections/reorder/friendship.jpg';
import ReorderSport from './images/collections/reorder/sport.jpg';
import w20PreorderSport from './images/collections/preorder/w20/sport.jpg';
import w20PreorderOuterWear from './images/collections/preorder/w20/outerwear.jpg';
import w20PreorderMain from './images/collections/preorder/w20/main.jpg';
import s21PreorderSport from './images/collections/preorder/s21/sport.jpg';
import s21PreorderSwim from './images/collections/preorder/s21/swim.jpg';
import s21PreorderOuterWear from './images/collections/preorder/s21/outerwear.jpg';
import s21PreorderMain from './images/collections/preorder/s21/main.jpg';
import w21PreorderSport from './images/collections/preorder/w21/sport.jpg';
import w21PreorderOuterWear from './images/collections/preorder/w21/outerwear.jpg';
import w21PreorderMain from './images/collections/preorder/w21/main.jpg';
import MissingBanner from './images/logobanner.jpg';
;
var CollectionChooser = /** @class */ (function (_super) {
    __extends(CollectionChooser, _super);
    function CollectionChooser() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            imagesIsLoded: false,
            imagesLoaded: 1,
            initialized: true,
            sortedCollections: []
        };
        _this.imageDoneLoading = function () {
            if (!_this.props.collections)
                return;
            var imagesLoaded = _this.state.imagesLoaded;
            imagesLoaded++;
            _this.setState({
                imagesIsLoded: _this.props.collections.length <= imagesLoaded,
                imagesLoaded: imagesLoaded
            });
        };
        return _this;
    }
    CollectionChooser.prototype.componentDidMount = function () {
        // if (this.props.collections && this.props.collections.length && !this.state.initialized) {
        //     let sortedCollections = [];
        //     if (this.props.collections) {
        //         sortedCollections = this.props.collections.sort((a, b) => (a.sort > b.sort) ? 1 : -1)
        //         this.setState({ initialized: true, sortedCollections })    
        //     }
        // }
    };
    CollectionChooser.prototype.componentDidUpdate = function (prevProps, prevState) {
        // if (
        //     (this.props.collections && this.props.collections.length && !this.state.initialized)
        //     || (this.props.collections && prevProps.collections &&
        //         this.props.collections.length !== prevProps.collections.length
        //         && this.props.collections && this.state.initialized)
        //     ) {
        //     let sortedCollections = [];
        //     if (this.props.collections) {
        //         sortedCollections = this.props.collections.sort((a, b) => (a.sort > b.sort) ? 1 : -1)
        //         this.setState({ initialized: true, sortedCollections })    
        //     }
        // }
    };
    CollectionChooser.prototype.isOdd = function (num) { return num % 2; };
    CollectionChooser.prototype.render = function () {
        var _this = this;
        var orderType = this.props.orderType;
        var sortedCollections = this.state.sortedCollections;
        var reOrderBackgroundImages = {
            'swim': ReorderSwim,
            'main': ReorderMain,
            'outerwear': ReorderOuterWear,
            'sport': ReorderSport,
            'friendship': ReorderFriendship
        };
        var w20preOrderBackgroundImages = {
            'main': w20PreorderMain,
            'outerwear': w20PreorderOuterWear,
            'sport': w20PreorderSport,
        };
        var s21preOrderBackgroundImages = {
            'swim': s21PreorderSwim,
            'main': s21PreorderMain,
            'outerwear': s21PreorderOuterWear,
            'sport': s21PreorderSport,
        };
        var w21preOrderBackgroundImages = {
            'main': w21PreorderMain,
            'outerwear': w21PreorderOuterWear,
            'sport': w21PreorderSport,
        };
        var getImage = function (imgUrl) {
            return (React.createElement("img", { src: _this.props.loadImage && _this.props.loadImage(imgUrl), className: "card-list__item__image", onError: function (el) {
                    el.target.src = MissingBanner;
                    el.target.classList.add('missing');
                }, onLoad: _this.imageDoneLoading }));
        };
        return (React.createElement(React.Fragment, null,
            (!this.state.initialized || !this.state.imagesIsLoded) &&
                React.createElement("div", { style: { height: '100vh', width: '100vw', position: 'fixed' } },
                    React.createElement(MoloRingloader, null)),
            React.createElement("div", { className: "card-list__wrapper " + ((!this.state.initialized || !this.state.imagesIsLoded) ? "" : "fade-in"), style: { visibility: (!this.state.initialized || !this.state.imagesIsLoded) ? 'hidden' : 'visible' } },
                React.createElement("ul", { className: "card-list" + ((this.props.collections && this.props.collections.length > 2) ? ' card-list--small' : '') },
                    this.props.collections && this.props.collections.map(function (collection, key) {
                        return collection.collectionName && React.createElement("li", { key: collection.collectionName, className: "card-list__item" },
                            React.createElement("div", { onClick: function () { return _this.props.handleOnClick && _this.props.handleOnClick(collection.collectionName); }, className: "card-list__item__link" },
                                getImage(collection.imgUrl),
                                React.createElement("div", { className: "card-list__item__title" }, collection.collectionName || '?!?')));
                    }),
                    this.props.collections && this.isOdd(this.props.collections.length) ?
                        React.createElement("li", { className: "card-list__item" },
                            React.createElement("div", { className: "card-list__item__link --not-active" },
                                React.createElement("img", { src: MissingBanner, alt: 'missing placeholder', className: "card-list__item__image --no-hover --placeholder missing" })))
                        :
                            null))));
    };
    return CollectionChooser;
}(Component));
export { CollectionChooser };
export default CollectionChooser;
//# sourceMappingURL=CollectionsChooser.js.map